import React from 'react'

import * as S from './styles'

interface IPageTitleProps {
	text?: string
	children?: JSX.Element | JSX.Element[] | null
	style?: React.CSSProperties
}

const PageTitle = ({ text, children, style }: IPageTitleProps) => {
	return (
		<S.Grid container direction="row" style={style}>
			{text && <S.Title variant="h1">{text}</S.Title>}
			{children}
		</S.Grid>
	)
}

export { PageTitle }
